var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7737_105387)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 10,
    r: 10,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.623 20C11.982 19.8333 11.321 19.7211 10.7037 19.4911C7.27855 18.2171 5.06035 15.805 4.25486 12.2305C3.13982 7.28037 5.76889 2.46562 10.4717 0.648893C16.0844 -1.5194 22.497 1.96679 23.7647 7.82746C24.8415 12.8058 22.1299 17.68 17.5303 19.4097C16.9024 19.6459 16.2295 19.7625 15.5773 19.9355C15.5091 19.9536 15.4422 19.9781 15.3746 19.9994H12.623V20ZM14.0126 19.149C19.0468 19.1295 23.1243 15.0286 23.0942 10.0139C23.0642 4.97358 19.0149 0.92463 14.0019 0.921496C8.98269 0.918363 4.89712 5.01369 4.90463 10.0409C4.91276 15.0775 9.0027 19.1678 14.0126 19.149Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1269 14.0471C16.1269 14.3818 16.0062 14.5886 15.651 14.7008C15.1044 14.8731 14.576 15.0755 13.9875 15.0624C12.8431 15.036 12.2252 14.3135 12.4653 13.1955C12.6223 12.4648 12.8606 11.7516 13.0463 11.0266C13.1332 10.685 13.2133 10.3366 13.2396 9.98629C13.2783 9.48119 13.0194 9.25308 12.5129 9.30948C12.2684 9.33706 12.0276 9.40098 11.7856 9.4486C11.7731 9.0068 11.8393 8.91154 12.2246 8.76741C12.8112 8.54807 13.3978 8.35631 14.0413 8.39454C14.9506 8.44843 15.5316 9.03124 15.399 9.92362C15.282 10.7107 15.0269 11.4765 14.8386 12.2536C14.748 12.6277 14.6504 13.0012 14.591 13.381C14.5153 13.8667 14.7292 14.1242 15.2189 14.133C15.5147 14.138 15.8111 14.0791 16.1275 14.0471H16.1269Z",
    fill: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2653 6.19497C16.2641 6.85361 15.7 7.3631 14.9796 7.35683C14.2823 7.35056 13.7213 6.83669 13.7144 6.19748C13.7069 5.55075 14.281 5.02372 14.9933 5.02246C15.7144 5.02121 16.2666 5.52944 16.2653 6.19497Z",
    fill: "#FFFCF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7737_105387",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7737_105387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7737_105387",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoActive);
export default __webpack_public_path__ + "static/media/info_active.9cf1fd1024f50e1017764e86f4b36bc1.svg";
export { ForwardRef as ReactComponent };